const stats = [
    {
        number: "1K",
        label: "Products",
    },
    {
        number: "20K",
        label: "Successfully sold",
    },
    {
        number: "5",
        label: "Years",
    },
];

const WhyChooseUs = () => {
    return (
        <section
            id="whychooseus"
            className="relative min-h-screen overflow-hidden px-6 pt-20 md:px-12 lg:px-20"
        >
            <div className="mx-auto flex min-h-[85vh] w-full max-w-[1600px] items-center">

                <div className="block w-full md:flex">

                    {/* LEFT */}
                    <div className="flex flex-col justify-between md:min-h-[700px] md:w-1/3 md:pr-8">

                        {/* Heading */}
                        <div className="pt-4 md:pt-8">
                            <span className="px-4 text-5xl font-bold md:px-8 md:text-7xl">
                                Why
                            </span>
                            <br />

                            <span className="px-4 text-5xl font-bold md:px-8 md:text-7xl">
                                Choose
                            </span>
                            <br />

                            <span className="px-4 text-5xl font-bold text-indigo-600 md:px-8 md:text-7xl">
                                US?
                            </span>

                            <p className="max-w-sm px-4 pt-6 leading-7 text-gray-600 md:px-8">
                                Every day we work hard to make the choices
                                of our clients better!
                            </p>
                        </div>

                        {/* Stats */}
                        <div className="mt-16 grid grid-cols-3 md:mt-20">
                            {stats.map((stat) => (
                                <div
                                    key={stat.label}
                                    className="group border-gray-200 py-6 text-center md:border-r md:px-4 md:last:border-r-0"
                                >
                                    <div className="text-3xl font-black tracking-tighter transition-transform duration-500 group-hover:-translate-y-2 md:text-5xl">
                                        {stat.number}
                                        <span className="text-indigo-600">
                                            +
                                        </span>
                                    </div>

                                    <div className="mt-3 text-[10px] uppercase tracking-widest text-gray-500 md:text-xs">
                                        {stat.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>


                    {/* MIDDLE */}
                    <div className="relative mt-12 overflow-hidden bg-yellow-100 md:mt-0 md:min-h-[700px] md:w-1/3">

                        {/* Background decoration */}
                        <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-yellow-200/60" />
                        <div className="absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-yellow-200/60" />

                        <div className="relative flex min-h-[500px] flex-col justify-between p-8 md:min-h-[700px] md:p-12">

                            {/* Top */}
                            <div className="flex items-center justify-between">
                                <span className="text-sm font-medium uppercase tracking-[0.3em] text-gray-600">
                                    Simple
                                </span>

                                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-black text-sm text-white">
                                    01
                                </span>
                            </div>

                            {/* Center */}
                            <div className="py-16 text-center">

                                <div className="mb-8 text-7xl font-black tracking-tighter md:text-8xl">
                                    01
                                </div>

                                <h3 className="text-4xl font-bold md:text-5xl">
                                    Start
                                </h3>

                                <h3 className="mt-1 text-4xl font-bold md:text-5xl">
                                    Choose
                                </h3>

                                <h3 className="mt-1 text-4xl font-bold text-indigo-600 md:text-5xl">
                                    Buy
                                </h3>

                                <p className="mx-auto mt-8 max-w-xs text-sm leading-6 text-gray-600">
                                    Find exactly what you are looking for
                                    from thousands of products available
                                    on our marketplace.
                                </p>
                            </div>

                            {/* Bottom */}
                            <div className="flex items-center justify-between border-t border-black/10 pt-6">
                                <span className="text-xs uppercase tracking-widest text-gray-500">
                                    Easy shopping
                                </span>

                                <span className="text-2xl">
                                    →
                                </span>
                            </div>
                        </div>
                    </div>


                    {/* RIGHT */}
                    <div className="relative mt-6 overflow-hidden bg-gray-100 md:mt-0 md:min-h-[700px] md:w-1/3">

                        <div className="flex min-h-[500px] flex-col p-8 md:min-h-[700px] md:p-12">

                            {/* Top */}
                            <div className="flex items-center justify-between">
                                <span className="text-sm font-medium uppercase tracking-[0.3em] text-gray-600">
                                    Trusted
                                </span>

                                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-600 text-sm text-white">
                                    02
                                </span>
                            </div>

                            {/* Content */}
                            <div className="flex flex-1 flex-col justify-center">

                                <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-white text-3xl shadow-sm">
                                    ✓
                                </div>

                                <h3 className="text-4xl font-bold leading-tight md:text-5xl">
                                    Quality
                                    <br />
                                    You Can
                                    <br />
                                    <span className="text-indigo-600">
                                        Trust.
                                    </span>
                                </h3>

                                <p className="mt-8 max-w-sm text-sm leading-7 text-gray-600">
                                    We carefully select our products and
                                    sellers to make sure you get quality,
                                    reliable and valuable products every
                                    time you shop.
                                </p>

                                {/* Features */}
                                <div className="mt-10 space-y-4">

                                    <div className="flex items-center gap-4 border-b border-gray-200 pb-4">
                                        <span className="text-indigo-600">
                                            ✓
                                        </span>

                                        <span className="text-sm font-medium">
                                            Carefully selected products
                                        </span>
                                    </div>

                                    <div className="flex items-center gap-4 border-b border-gray-200 pb-4">
                                        <span className="text-indigo-600">
                                            ✓
                                        </span>

                                        <span className="text-sm font-medium">
                                            Trusted sellers
                                        </span>
                                    </div>

                                    <div className="flex items-center gap-4">
                                        <span className="text-indigo-600">
                                            ✓
                                        </span>

                                        <span className="text-sm font-medium">
                                            Secure shopping experience
                                        </span>
                                    </div>

                                </div>
                            </div>

                            {/* Bottom */}
                            <div className="border-t border-gray-200 pt-6">
                                <span className="text-xs uppercase tracking-widest text-gray-500">
                                    Shop with confidence
                                </span>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;